const TIMINGS_INTERVAL_DEFAULT = 20000;

export function getTimingsInterval(): number {
    return TIMINGS_INTERVAL_DEFAULT;
}
